export const iconList = {
  bar: (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke="#000000"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g fill="#000000">
          {" "}
          <path d="M12 2a1 1 0 011 1v10a1 1 0 11-2 0V3a1 1 0 011-1zM8 6a1 1 0 011 1v6a1 1 0 11-2 0V7a1 1 0 011-1zM5 10a1 1 0 00-2 0v3a1 1 0 102 0v-3z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  ),

  "horizontal bar": (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      transform="rotate(90)"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g fill="#000000">
          {" "}
          <path d="M12 2a1 1 0 011 1v10a1 1 0 11-2 0V3a1 1 0 011-1zM8 6a1 1 0 011 1v6a1 1 0 11-2 0V7a1 1 0 011-1zM5 10a1 1 0 00-2 0v3a1 1 0 102 0v-3z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  ),

  line: (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M3 16.5L9 10L13 16L21 6.5"
          stroke="#000000"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>{" "}
      </g>
    </svg>
  ),

  pie: (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.75 3.75H12V12H20.25V11.25C20.25 7.10786 16.8921 3.75 12.75 3.75ZM13.5 10.5V5.29642C16.214 5.63486 18.3651 7.78596 18.7036 10.5H13.5ZM4.5 13.5C4.5 10.4403 6.79027 7.91549 9.75 7.54642V14.25H16.4536C16.0845 17.2097 13.5597 19.5 10.5 19.5C7.18629 19.5 4.5 16.8137 4.5 13.5ZM10.5 6C6.35786 6 3 9.35786 3 13.5C3 17.6421 6.35786 21 10.5 21C14.6421 21 18 17.6421 18 13.5V12.75H11.25V6H10.5Z"
          fill="#080341"
        ></path>{" "}
      </g>
    </svg>
  ),

  area: (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path
          d="M0.5 14.5H0V15H0.5V14.5ZM6.5 5.5L6.9 5.2C6.80264 5.07018 6.64833 4.99569 6.48613 5.00019C6.32392 5.00469 6.17399 5.08763 6.08397 5.22265L6.5 5.5ZM9.5 9.5L9.1 9.8C9.19566 9.92754 9.3464 10.0018 9.50581 9.99997C9.66523 9.99811 9.8142 9.92035 9.90687 9.79062L9.5 9.5ZM0 0V14.5H1V0H0ZM0.5 15H15V14H0.5V15ZM2.91603 11.7774L6.91603 5.77735L6.08397 5.22265L2.08397 11.2226L2.91603 11.7774ZM6.1 5.8L9.1 9.8L9.9 9.2L6.9 5.2L6.1 5.8ZM9.90687 9.79062L14.9069 2.79062L14.0931 2.20938L9.09313 9.20938L9.90687 9.79062Z"
          fill="#000000"
        ></path>{" "}
      </g>
    </svg>
  ),

  scatter: (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <path fill="#444" d="M1 15v-15h-1v16h16v-1h-15z"></path>{" "}
        <path
          fill="#444"
          d="M5 11c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
        ></path>{" "}
        <path
          fill="#444"
          d="M8 6c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
        ></path>{" "}
        <path
          fill="#444"
          d="M14 5c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
        ></path>{" "}
        <path
          fill="#444"
          d="M11 10c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
        ></path>{" "}
      </g>
    </svg>
  ),

  radar: (
    <svg
      fill="#000000"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      viewBox="0 0 96.946 96.946"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        {" "}
        <g>
          {" "}
          <path d="M48.473,2.372L0,37.591l18.515,56.984h59.917l18.515-56.984L48.473,2.372z M49.023,6.642L92.48,38.214l-11.082,2.488 c-0.352-0.85-1.188-1.451-2.166-1.451c-0.203,0-0.396,0.035-0.584,0.082L50.749,15.828c0.042-0.176,0.07-0.357,0.07-0.545 c0-1.105-0.767-2.025-1.796-2.273V6.642z M64.893,77.723l-37.174,4.783c-0.079-0.162-0.177-0.312-0.29-0.451l6.233-9.592 c0.235,0.078,0.483,0.131,0.745,0.131c1.296,0,2.347-1.051,2.347-2.346c0-0.002,0-0.004,0-0.004l19.603-4.85 c0.408,0.69,1.152,1.16,2.013,1.16c0.338,0,0.657-0.074,0.946-0.203l6.267,9.641c-0.429,0.426-0.694,1.014-0.694,1.664 C64.887,77.68,64.893,77.703,64.893,77.723z M34.354,44.817c-0.049-0.232-0.14-0.447-0.251-0.648l12.857-9.34 c0.275,0.232,0.6,0.406,0.962,0.494v12.531L34.354,44.817z M47.645,48.92L35.212,68.053c-0.139-0.051-0.283-0.088-0.433-0.113 l-1.927-20.438c0.708-0.256,1.252-0.838,1.458-1.568L47.645,48.92z M46.127,33.048c0,0.318,0.064,0.619,0.179,0.895l-12.947,9.408 c-0.372-0.248-0.818-0.395-1.298-0.395c-0.761,0-1.431,0.367-1.859,0.93l-10.725-2.4c-0.025-0.109-0.059-0.215-0.099-0.316 l28.167-23.732c0.121,0.051,0.248,0.088,0.377,0.121v13.217C46.894,31.022,46.127,31.942,46.127,33.048z M19.452,42.608l10.3,2.307 c-0.021,0.127-0.039,0.254-0.039,0.387c0,1.191,0.892,2.166,2.042,2.316l1.924,20.41c-0.938,0.307-1.621,1.18-1.621,2.221 c0,0.636,0.255,1.209,0.665,1.632l-6.172,9.497c-0.123-0.053-0.253-0.094-0.386-0.125l-7.472-37.453 C19.059,43.494,19.327,43.081,19.452,42.608z M57.768,61.949l-8.4-12.927l13.302-2.985c0.163,0.494,0.478,0.922,0.901,1.209 l-4.764,14.662c-0.143-0.026-0.289-0.045-0.438-0.045C58.158,61.863,57.96,61.897,57.768,61.949z M60.188,65.672 c0.324-0.402,0.525-0.908,0.525-1.465c0-0.748-0.355-1.406-0.9-1.836l4.793-14.75c0.093,0.012,0.185,0.027,0.281,0.027 c1.295,0,2.346-1.051,2.346-2.346c0-0.098-0.018-0.191-0.029-0.287L77.21,42.77c0.196,0.338,0.47,0.619,0.804,0.824L67.692,75.358 c-0.149-0.028-0.302-0.047-0.46-0.047c-0.247,0-0.48,0.05-0.704,0.119L60.188,65.672z M49.023,17.558 c0.131-0.033,0.258-0.07,0.379-0.121l27.652,23.297c-0.106,0.268-0.17,0.559-0.17,0.865c0,0.039,0.01,0.076,0.012,0.113 l-10.078,2.264c-0.422-0.613-1.131-1.018-1.932-1.018c-0.48,0-0.927,0.145-1.299,0.393l-12.947-9.408 c0.113-0.275,0.179-0.576,0.179-0.895c0-1.105-0.767-2.025-1.796-2.273V17.558L49.023,17.558z M49.023,35.324 c0.363-0.088,0.688-0.262,0.963-0.494l12.857,9.342c-0.129,0.232-0.222,0.484-0.267,0.758l-13.554,3.043V35.324L49.023,35.324z M56.797,62.477c-0.474,0.431-0.775,1.043-0.775,1.73c0,0.045,0.011,0.088,0.013,0.131l-19.552,4.838 c-0.096-0.186-0.213-0.356-0.354-0.512L48.473,49.67L56.797,62.477z M47.922,6.642v6.367c-1.028,0.248-1.795,1.168-1.795,2.273 c0,0.188,0.028,0.369,0.07,0.545L17.8,39.752c-0.194-0.053-0.395-0.09-0.606-0.09c-0.747,0-1.405,0.355-1.834,0.9L4.562,38.145 L47.922,6.642z M3.78,39.101l11.109,2.486c-0.025,0.137-0.042,0.277-0.042,0.422c0,1.109,0.771,2.033,1.805,2.277l7.47,37.441 c-0.518,0.43-0.855,1.07-0.855,1.797c0,0.688,0.3,1.299,0.77,1.729l-3.507,5.395L3.78,39.101z M21.326,91.447l3.68-5.664 c0.194,0.053,0.396,0.09,0.607,0.09c0.894,0,1.662-0.506,2.058-1.241l38.407-4.941c0.342,0.195,0.732,0.316,1.154,0.316 c0.3,0,0.584-0.062,0.848-0.164l7.541,11.604H21.326z M76.417,90.647l-7.435-11.438c0.367-0.416,0.596-0.952,0.596-1.551 c0-0.291-0.061-0.567-0.156-0.826l10.75-33.086c0.768-0.336,1.312-1.076,1.387-1.951l11.576-2.6L76.417,90.647z"></path>{" "}
        </g>{" "}
      </g>
    </svg>
  ),

  table: (
    <svg
      fill="#000000"
      height="22px"
      width="22px"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 511 511"
    >
      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M471.5,56h-432C17.72,56,0,73.72,0,95.5v320C0,437.28,17.72,455,39.5,455h432c21.78,0,39.5-17.72,39.5-39.5v-320 C511,73.72,493.28,56,471.5,56z M175,376v-49h161v49H175z M336,391v49H175v-49H336z M496,135v49H351v-49H496z M336,199v49H175v-49 H336z M160,248H15v-49h145V248z M160,263v49H15v-49H160z M175,263h161v49H175V263z M351,263h145v49H351V263z M351,248v-49h145v49 H351z M336,184H15v-49h321V184z M15,327h145v49H15V327z M351,327h145v49H351V327z M39.5,71h432c13.509,0,24.5,10.991,24.5,24.5V120 H15V95.5C15,81.991,25.991,71,39.5,71z M15,415.5V391h145v49H39.5C25.991,440,15,429.009,15,415.5z M471.5,440H351v-49h145v24.5 C496,429.009,485.009,440,471.5,440z"></path>{" "}
        </g>
      </g>
    </svg>
  ),
};

const BlueColorArray = ["#2563EB", "#60A8FB", "#3B86F7", "#90C7FE", "#BEDCFE"];
const blueSize = BlueColorArray.length;

const RedColorArray = ["#E21D48", "#FBD5DA", "#F17E92", "#F7ABB6", "#E9536F"];
const redSize = RedColorArray.length;

const DarkColorArray = ["#414144", "#E6E5E5", "#BCBCBD", "#939395", "#6A6A6C"];
const darkSize = DarkColorArray.length;

const GreenColorArray = ["#125427", "#1DC355", "#098637", "#113B1D", "#0E2014"];
const greenSize = GreenColorArray.length;

const BrownColorArray = ["#60432F", "#765337", "#8F633D", "#AD7C48", "#BB9054"];
const brownSize = BrownColorArray.length;

const ColorGroupArray = [
  {
    arr: BlueColorArray,
    len: blueSize,
  },
  {
    arr: RedColorArray,
    len: redSize,
  },
  {
    arr: DarkColorArray,
    len: darkSize,
  },
  {
    arr: GreenColorArray,
    len: greenSize,
  },
  {
    arr: BrownColorArray,
    len: brownSize,
  },
];

export const randomColorGenerator = (id) => {
  const ind = Number(id) % ColorGroupArray.length || 0;
  return ColorGroupArray[ind];
};

export function formatSingleLineSQL(sql) {
  return sql
    .replace(/\bSELECT\b/g, '<span class="text-[#4CAF50]">SELECT</span>')
    .replace(/\bFROM\b/g, '<span class="text-[#FF9800]">FROM</span>')
    .replace(/\bWHERE\b/g, '<span class="text-[#2196F3]">WHERE</span>')
    .replace(/\bGROUP BY\b/g, '<span class="text-[#9C27B0]">GROUP BY</span>')
    .replace(/\bORDER BY\b/g, '<span class="text-[#FFC107]">ORDER BY</span>')
    .replace(/\bLIMIT\b/g, '<span class="text-[#3F51B5]">LIMIT</span>')
    .replace(/\bAS\b/g, '<span class="text-[#795548]">AS</span>')
    .replace(/\bON\b/g, '<span class="text-[#E91E63]">ON</span>')
    .replace(/\bJOIN\b/g, '<span class="text-[#4CAF50]">JOIN</span>')
    .replace(/\bAND\b/g, '<span class="text-[#9E9E9E]">AND</span>')
    .replace(/\bOR\b/g, '<span class="text-[#607D8B]">OR</span>')
    .replace(/\bINSERT\b/g, '<span class="text-[#FF5722]">INSERT</span>')
    .replace(/\bUPDATE\b/g, '<span class="text-[#673AB7]">UPDATE</span>')
    .replace(/\bDELETE\b/g, '<span class="text-[#F44336]">DELETE</span>')
    .replace(/\bINTO\b/g, '<span class="text-[#03A9F4]">INTO</span>')
    .replace(/\bVALUES\b/g, '<span class="text-[#009688]">VALUES</span>')
    .replace(/\bDISTINCT\b/g, '<span class="text-[#8BC34A]">DISTINCT</span>')
    .replace(/\bHAVING\b/g, '<span class="text-[#CDDC39]">HAVING</span>')
    .replace(/\bCASE\b/g, '<span class="text-[#FFC107]">CASE</span>')
    .replace(/\bWHEN\b/g, '<span class="text-[#00BCD4]">WHEN</span>')
    .replace(/\bTHEN\b/g, '<span class="text-[#FFEB3B]">THEN</span>')
    .replace(/\bEND\b/g, '<span class="text-[#FF5722]">END</span>')
    .replace(/\bLEFT\b/g, '<span class="text-[#FF9800]">LEFT</span>')
    .replace(/\bRIGHT\b/g, '<span class="text-[#009688]">RIGHT</span>')
    .replace(/\bINNER\b/g, '<span class="text-[#4CAF50]">INNER</span>')
    .replace(/\bOUTER\b/g, '<span class="text-[#03A9F4]">OUTER</span>')
    .replace(/\bFULL\b/g, '<span class="text-[#673AB7]">FULL</span>')
    .replace(/\bCOUNT\b/g, '<span class="text-[#F06292]">COUNT</span>');
}

export function copyToClipboard(content) {
  if (!navigator.clipboard) {
    console.error("Clipboard API not supported in this browser");
    return;
  }

  // Convert JSON to a string if the input is an object
  const text =
    typeof content === "object"
      ? JSON.stringify(content, null, 2)
      : String(content);

  navigator.clipboard
    .writeText(text)
    .then(() => {})
    .catch((err) => {});
}

export const formatLargeNumber = (value) => {
  if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}B`;
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return value;
};

export const formatEpochDate = (value) => {
  const d = new Date(value);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};
export const defaultChartConfigData = {
  topMargin: 10,
  rightMargin: 10,
  leftMargin: 0,
  bottomMargin: 20,
  xAxisRotation: 0,
  yAxisorientation: "left",
};

export const defaultHeatMapResult = {
  query_result: [
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 99,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 94,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.74,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 1.29,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 24,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.08,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 76,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 315.36,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 56.45,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0.42,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 294.73,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 74.1,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 124.05,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 100,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 1.29,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.74,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 14,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.08,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0.63,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0.03,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0.16,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0.47,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0.32,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0.21,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "GOPI",
      t1_d185_aimx_metric: 16,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 100,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 100,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 100,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.74,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 1.28,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.08,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 16,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.51,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 377.11,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 55,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 100,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 100,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 60,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 54.29,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 367.91,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 94.56,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 5.93,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.05,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.74,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 17,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 1.28,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 283.72,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 70.59,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-JNN3UBR",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 120.02,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 358.12,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 54.37,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 12,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.74,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 1.29,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "DESKTOP-5MJONN7",
      t1_d185_aimx_metric: 1.32,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0,
    },
    {
      t1_d185_aimx_state: "null",
      t1_d185_aimx_country: "null",
      t1_d185_aimx_groups: "null",
      t1_d185_aimx_machine: "95PZVR1",
      t1_d185_aimx_metric: 0.08,
    },
  ],
};

export const defaultTimeSeriesResults = {
  query_result: [
    {
      t1_d185_aimx_dtime_day: 1733616000000,
      t1_d185_aimx_metric_average_of_metric: 51.009354838709676,
    },
    {
      t1_d185_aimx_dtime_day: 1733184000000,
      t1_d185_aimx_metric_average_of_metric: 62.53125,
    },
    {
      t1_d185_aimx_dtime_day: 1732752000000,
      t1_d185_aimx_metric_average_of_metric: 27.74804274465691,
    },
    {
      t1_d185_aimx_dtime_day: 1733270400000,
      t1_d185_aimx_metric_average_of_metric: 39.733333333333334,
    },
    {
      t1_d185_aimx_dtime_day: 1732838400000,
      t1_d185_aimx_metric_average_of_metric: 38.13117982873451,
    },
    {
      t1_d185_aimx_dtime_day: 1732492800000,
      t1_d185_aimx_metric_average_of_metric: 34.52255624999996,
    },
    {
      t1_d185_aimx_dtime_day: 1733788800000,
      t1_d185_aimx_metric_average_of_metric: 22.347173625051283,
    },
    {
      t1_d185_aimx_dtime_day: 1732924800000,
      t1_d185_aimx_metric_average_of_metric: 49.76379912663755,
    },
    {
      t1_d185_aimx_dtime_day: 1733875200000,
      t1_d185_aimx_metric_average_of_metric: 16.48292749452359,
    },
    {
      t1_d185_aimx_dtime_day: 1733443200000,
      t1_d185_aimx_metric_average_of_metric: 87.9,
    },
    {
      t1_d185_aimx_dtime_day: 1733011200000,
      t1_d185_aimx_metric_average_of_metric: 28.9056807511737,
    },
    {
      t1_d185_aimx_dtime_day: 1732579200000,
      t1_d185_aimx_metric_average_of_metric: 32.9902448634956,
    },
    {
      t1_d185_aimx_dtime_day: 1733097600000,
      t1_d185_aimx_metric_average_of_metric: 69.56010600706713,
    },
    {
      t1_d185_aimx_dtime_day: 1733961600000,
      t1_d185_aimx_metric_average_of_metric: 13.34453383758609,
    },
    {
      t1_d185_aimx_dtime_day: 1733529600000,
      t1_d185_aimx_metric_average_of_metric: 3.2720731707317072,
    },
    {
      t1_d185_aimx_dtime_day: 1732665600000,
      t1_d185_aimx_metric_average_of_metric: 31.548261818181828,
    },
  ],
};
